import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NavigationSidebarSourcing } from '@/areas/sourcing-scenarios/SourcingScenarios/components/NavigationSidebarSourcing';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The scenario's pages beside the Sourcing sidebar, which opens the scenario's entries; the purchase orders stay outside.
export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar',
)({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { projectId, sourcingScenarioId } = Route.useParams();
    return (
        <SidebarRouteLayout
            sidebar={<NavigationSidebarSourcing rfqId={projectId} sourcingScenarioId={sourcingScenarioId} />}
        >
            <Outlet />
        </SidebarRouteLayout>
    );
}
